import { defineMessages } from 'react-intl';

export default defineMessages({
    addDriverButton: {
        id: 'ml.gateway.quoteandbind.pa.drivers.addDriverButton',
        defaultMessage: 'ADD DRIVER'
    },
    wellWorkOnYourAdditionalDriversNext: {
        id: 'ml.gateway.quoteandbind.pa.drivers.We\'ll work on your additional drivers next',
        defaultMessage: 'We\'ll work on your {additionalDrivers} next'
    },
    wellWorkOnYourVehiclesNext: {
        id: 'ml.gateway.quoteandbind.pa.drivers.We\'ll work on your vehicles next',
        defaultMessage: 'We\'ll work on your {vehicles} next'
    },
    additionalDrivers: {
        id: 'ml.gateway.quoteandbind.pa.drivers.additional drivers',
        defaultMessage: 'additional drivers'
    },
    vehicles: {
        id: 'ml.gateway.quoteandbind.pa.drivers.vehicles',
        defaultMessage: 'vehicles'
    },
    alertMessage: {
        id: 'ml.gateway.quoteandbind.pa.drivers.alertMessage',
        defaultMessage: '{object} {message}'
    },
    undo: {
        id: 'ml.gateway.quoteandbind.pa.drivers.Undo',
        defaultMessage: 'Undo'
    },
    nonAccidentPreventionWarning: {
        id: 'ml.gateway.quoteandbind.pa.drivers.To receive the Accident Prevention Course discount, all drivers need to have completed a prevention course.',
        defaultMessage: 'To receive the Accident Prevention Course discount, all drivers need to have completed a prevention course.'
    },
    selfSelected_Ext : {
        id: "ml.gateway.quoteandbind.pa.Self has already been selected as a relationship to insured on another driver", 
        defaultMessage: "Self has already been selected as a relationship to insured on another driver."
    },
    spouseSelected_Ext : {
        id: "ml.gateway.quoteandbind.pa.gateway.Spouse was already selected as a relationship to insured on another driver", 
        defaultMessage: "Spouse was already selected as a relationship to insured on another driver."
    },
    validate: {
        id: 'ml.gateway.quoteandbind.pa.drivers.validate',
        defaultMessage: 'validate'
    },
    validationNext: {
        id: 'ml.gateway.quoteandbind.pa.drivers.validationNext',
        defaultMessage: 'Next, we\'ll {validate} all information provided'
    },
    selectDriver: {
        id: 'ml.gateway.quoteandbind.pa.drivers.selectDriver',
        defaultMessage: 'Please enter the missing information. This is a required field.'
    },
    accountHolderMinAge: {
        id: 'ml.gateway.quoteandbind.pa.accountHolderMinAge',
        defaultMessage: 'We are unable to continue with your quote because this product is not available for applicants younger than 18 years old.'
    }
});